<template>
  <div class="applicationPC" :class="`applicationPC--${id}`">
    <div class="zy_constr">
      <Tabs :tabs="tabs" :currentTab="currentTab" @onClick="handleClick" />
      <div v-if="currentApp && currentVisible" class="applicationPC-main applicationPC-main--current">
        <img :src="currentApp.logo" alt="" class="applicationPC-logo" />
        <div class="applicationPC-desc">
          <div class="applicationPC-desc__row" v-for="item in currentApp.desc" :key="item">
            {{ item }}
          </div>
        </div>
        <div class="applicationPC-link">
          <img v-if="currentApp.qrcode" :src="currentApp.qrcode" alt="" class="applicationPC-qrcode" />
          <a v-if="currentApp.web" class="applicationPC-web" :href="currentApp.web.url" target="_blank">
            <img
              class="applicationPC-web__icon"
              src="https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/74ba7bba-cd1e-49f8-bf2e-647575dee2ba.png"
              alt=""
            />
            <div class="applicationPC-web__title">{{ currentApp.web.name }}</div>
            <div class="applicationPC-web__link link">
              <span class="link-dot"></span>
            </div>
          </a>
        </div>
      </div>
      <div v-if="prevApp && prevVisible" class="applicationPC-main applicationPC-main--prev">
        <img :src="prevApp.logo" alt="" class="applicationPC-logo" />
        <div class="applicationPC-desc">
          <div class="applicationPC-desc__row" v-for="item in prevApp.desc" :key="item">
            {{ item }}
          </div>
        </div>
        <div class="applicationPC-link">
          <img v-if="prevApp.qrcode" :src="prevApp.qrcode" alt="" class="applicationPC-qrcode" />
          <a v-if="prevApp.web" class="applicationPC-web" :href="prevApp.web.url" target="_blank">
            <img
              class="applicationPC-web__icon"
              src="https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/74ba7bba-cd1e-49f8-bf2e-647575dee2ba.png"
              alt=""
            />
            <div class="applicationPC-web__title">{{ prevApp.web.name }}</div>
            <div class="applicationPC-web__link link">
              <span class="link-dot"></span>
            </div>
          </a>
        </div>
      </div>
      <div
        v-if="prevApp && prevVisible"
        class="applicationPC-img applicationPC-img--prev"
        :class="[`applicationPC-img--${prevApp.id}`]"
      >
        <img :src="prevApp.imgs[0]" alt="" />
        <img v-if="prevApp.imgs[1]" :src="prevApp.imgs[1]" alt="" />
      </div>
      <div
        v-if="currentApp && currentVisible"
        class="applicationPC-img applicationPC-img--current"
        :class="[`applicationPC-img--${currentApp.id}`]"
      >
        <img :src="currentApp.imgs[0]" alt="" />
        <img v-if="currentApp.imgs[1]" :src="currentApp.imgs[1]" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from 'vue-tabs-with-active-line';

export default {
  name: 'ApplicationPC',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    Tabs
  },
  data: function () {
    return {
      tabs: this.data.map(item => ({
        title: item.name,
        value: item.id
      })),
      currentTab: '',
      currentVisible: true,
      prevVisible: false,
      prevApp: null
    };
  },
  computed: {
    currentApp() {
      return this.data.find(item => item.id === this.currentTab);
    }
  },
  mounted() {
    // 使用 Intersection Observer 检测组件进入可视区域
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 组件进入可视区域时，确保 currentTab 有初始值
          if (!this.currentTab && this.data.length > 0) {
            this.currentTab = this.data[0].id;
          }
          // 组件进入可视区域后，停止观察
          this.observer.unobserve(entry.target);
        }
      });
    });

    // 开始观察组件
    this.$nextTick(() => {
      const element = this.$el;
      if (element) {
        this.observer.observe(element);
      }
    });
  },
  beforeDestroy() {
    // 组件销毁前清理 observer
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    handleClick(value) {
      this.currentVisible = false;

      this.$nextTick(() => {
        this.prevApp = { ...this.currentApp };
        this.currentTab = value;
        this.currentVisible = true;
        this.prevVisible = true;
      });

      setTimeout(() => {
        this.prevVisible = false;
      }, 300);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';
@import '@/styles/tabs.scss';
@import '@/styles/link.scss';

.zy_constr {
  position: relative;
  height: 100%;
}

.applicationPC {
  height: 687px;
  background: #f8f8fa;
  box-sizing: border-box;
  padding-top: 80px;
  &--overseaPC {
    height: 627px;
  }
}

.applicationPC-main {
  position: absolute;
  top: 87px;
  left: 0;
  width: 660px;
  &--prev {
    animation: textExit 0.3s ease-out forwards;
  }
  &--current {
    animation: textAppear 0.3s ease-out forwards;
  }
}

.applicationPC-logo {
  height: 48px;
  display: block;
}

.applicationPC-desc {
  margin-top: 36px;
  font-size: 16px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}

.applicationPC-desc__row {
  margin-top: 12px;
  &:first-child {
    margin-top: 0;
  }
}

.applicationPC-link {
  margin-top: 36px;
  display: flex;
}

.applicationPC-qrcode,
.applicationPC-web {
  box-sizing: border-box;
  width: 120px;
  height: 120px;
  border-radius: 12px;
  background-color: #fff;
  position: relative;
}

.applicationPC-qrcode {
  padding: 4px;
  margin-right: 24px;
}

.applicationPC-web {
  padding: 12px;
  &:hover {
    ::v-deep .applicationPC-web__link {
      &::after {
        border-color: #fff;
      }
      .link-dot {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.applicationPC-web__icon {
  width: 24px;
  height: 24px;
  display: block;
}

.applicationPC-web__title {
  margin-top: 12px;
  font-size: 14px;
  line-height: 18px;
  color: #000;
}

.applicationPC-web__link {
  position: absolute;
  right: 8px;
  bottom: 8px;
}

.applicationPC-img {
  width: 520px;
  height: 520px;
  position: absolute;
  right: -56px;
  bottom: 0;
  img {
    width: 284px;
    position: absolute;

    &:first-child {
      left: 0;
      bottom: 0;
    }
    &:last-child {
      right: 84px;
      bottom: 0;
    }
  }
  &--prev {
    img {
      &:first-child {
        animation: imageExitUpper 0.3s ease-out forwards;
      }
      &:last-child {
        animation: imageExitLower 0.3s ease-out forwards;
      }
    }
  }
  &--current {
    img {
      &:first-child {
        animation: imageAppearUpper 0.3s ease-out forwards;
      }
      &:last-child {
        animation: imageAppearLower 0.3s ease-out forwards;
      }
    }
  }

  &--monkey {
    width: 484px;
    height: 378px;
    right: 0;
    bottom: 108px;
    img {
      width: 100%;
    }
  }
  &--anime {
    img {
      &:first-child {
        width: 325px;
      }
      &:last-child {
        width: 319px;
      }
    }
  }
}

@keyframes imageAppearUpper {
  0% {
    opacity: 0;
    transform: translate(20px, 20px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}

@keyframes imageAppearLower {
  0% {
    opacity: 0;
    transform: translate(60px, 60px);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}

@keyframes imageExitUpper {
  0% {
    opacity: 1;
    transform: translate(0, 0);
  }
  100% {
    opacity: 0;
    transform: translate(20px, 20px);
  }
}

@keyframes imageExitLower {
  0% {
    opacity: 1;
    transform: translate(0, 0);
  }
  100% {
    opacity: 0;
    transform: translate(60px, 60px);
  }
}

@keyframes textAppear {
  0% {
    transform: translate(0, 24px);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes textExit {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
